import { createSelector } from '@reduxjs/toolkit'
import { LivedataServerData, LockType } from '@lk/api'

import { getLivedata as getRootLivedata } from '../root.selectors'
import { RootState } from '../root.reducer'
import { LivedataState } from './livedata.reducer'

export const getLivedata = createSelector<RootState, LivedataState, LivedataServerData>(
  getRootLivedata,
  (livedataRoot) => livedataRoot.data,
)

export const isLivedataLoaded = createSelector<RootState, LivedataState, boolean>(
  getRootLivedata,
  (livedataRoot) => livedataRoot.status === 'loaded',
)

export const isUserLocked = createSelector<RootState, LivedataState, boolean, boolean>(
  [getRootLivedata, isLivedataLoaded],
  (livedataRoot, isLoaded) => isLoaded && livedataRoot.data.OpenDayStatus.Locked === LockType.Locked,
)
